import { api } from '../api';

export const API_PUBLIC_ORGANIZATION_PATH = '/public/organization';

export const fetchOrganizationRoles = (organizationId) => api.get(`${API_PUBLIC_ORGANIZATION_PATH}/byId/${organizationId}/roles`);

export const fetchDefaultOrganization = () => api.get(`${API_PUBLIC_ORGANIZATION_PATH}/default`);
